<template>
  <div id="sidebar" class="hidden md:flex md:flex-shrink-0">
    <div class="flex flex-col w-64 orange-theme">
      <div class="flex-1 flex flex-col min-h-0 orange-theme">
        <div>
          <router-link :to="{ name: 'index' }">
            <div
              class="
                logo-holder
                flex
                items-center
                cursor-pointer
                py-4
                justify-center
                px-4
                bg-theme-support-color
              "
            >
              <img class="h-20 rounded-2xl w-auto" :src="logo" alt="Workflow" />
            </div>
          </router-link>
        </div>
        <div
          class="
            user_name
            border-0
            text-center
            pb-2
            px-2
            bg-theme-support-color
          "
        >
          <div class="text-white font-semibold text-md">
            {{ user.name
            }}{{
              user.role ? `(${user.role.name[$store.state.cache.locale]})` : ""
            }}
          </div>
          <div class="text-sm text-white font-semibold">
            {{ $store.state.auth.user.business_name }}
          </div>
        </div>
        <div class="menu-holder flex-1 flex flex-col overflow-y-auto">
          <nav class="flex-1 px-2 py-4 background-orange space-y-1">
            <div
              v-if="helper.isSpecificRole(['owner', 'manager', 'supervisor'])"
              class="background-orange group rounded-md"
            >
              <side-menu
                :route-list="[{ name: 'dashboard', label: 'dashboard' }]"
              >
                <template v-slot:content>
                  <router-link
                    :to="{ name: 'dashboard', label: 'dashboard' }"
                    class="
                      text-white
                      flex
                      items-center
                      text-sm
                      font-medium
                      rounded-md
                    "
                  >
                    <HomeIcon
                      class="mr-3 h-6 w-6"
                      aria-hidden="true"
                    ></HomeIcon>
                    <span class="side-menu-label">
                      {{ $t("message.dashboard") }}
                    </span>
                  </router-link>
                </template>
              </side-menu>
            </div>
            <side-menu
              v-if="
                helper.isSpecificRole([
                  'owner',
                  'manager',
                  'supervisor',
                  'staff',
                  'customer-service',
                ])
              "
              :menu-list="true"
              :route-list="[
                {
                  name: 'label'
                },
                {
                  name: 'new-label'
                }
              ]"
            >
              <template v-slot:content>
                <CubeIcon class="mr-3 h-6 w-6" aria-hidden="true"></CubeIcon>
                <span class="side-menu-label">
                  {{ $t("message.labels") }}
                </span>
              </template>

              <side-menu-item
                v-for="route in [
                  {
                    name: 'label',
                    params: { tab: 'search' },
                    label: 'label_list',
                  },
                  {
                    name: 'label-create',
                    label: 'new_label',
                  },
                ]"
                :key="route"
                :route="route"
                :label="route.label"
              ></side-menu-item>
                <!-- <router-link
                  :to="{ name: 'label', params: { tab: 'search' } }"
                  class="
                    text-white
                    flex
                    items-center
                    text-sm
                    font-medium
                    rounded-md
                  "
                >

                </router-link> -->

            </side-menu>
            <side-menu
              v-if="
                helper.isSpecificRole([
                  'owner',
                  'manager',
                  'supervisor',
                  'staff',
                ])
              "
              :route-list="[{ name: 'report', params: { tab: 'accepted' } }]"
            >
              <template v-slot:content>
                <router-link
                  :to="{ name: 'report', params: { tab: 'accepted' } }"
                  class="
                    text-white
                    flex
                    items-center
                    text-sm
                    font-medium
                    rounded-md
                  "
                >
                  <DocumentReportIcon
                    class="mr-3 h-6 w-6"
                    aria-hidden="true"
                  ></DocumentReportIcon>
                  <span class="side-menu-label">
                    {{ $t("message.report") }}
                  </span>
                </router-link>
              </template>
            </side-menu>
            <div class="background-orange group rounded-md">
              <side-menu
                :menu-list="true"
                :route-list="[
                  {
                    name: 'shipping-report.csv-list',
                  },
                ]"
              >
                <template v-slot:content>
                  <CashIcon class="mr-3 h-6 w-6" aria-hidden="true"></CashIcon>
                  <span class="side-menu-label">{{
                    $t("message.csv_menu")
                  }}</span>
                </template>
                <side-menu-item
                  v-for="route in [
                    {
                      name: 'shipping-report.csv-list',
                      label: 'shipping_report_csv_list',
                    },
                  ]"
                  :key="route"
                  :route="route"
                  :label="route.label"
                ></side-menu-item>
              </side-menu>
            </div>

            <side-menu
              v-if="helper.isSpecificRole(['owner', 'manager'])"
              :menu-list="false"
              :route-list="[{ name: 'staff' }]"
            >
              <template v-slot:content>
                <router-link
                  :to="{ name: 'staff', params: { tab: 'active' } }"
                  class="
                    text-white
                    flex
                    items-center
                    text-sm
                    font-medium
                    rounded-md
                  "
                >
                  <UserGroupIcon
                    class="mr-3 h-6 w-6"
                    aria-hidden="true"
                  ></UserGroupIcon>
                  <span class="side-menu-label">
                    {{ $t("message.staff") }}
                  </span>
                </router-link>
              </template>
            </side-menu>
            <side-menu
              :menu-list="false"
              :route-list="[{ name: 'pickup-request' }]"
            >
              <template v-slot:content>
                <router-link
                  :to="{ name: 'pickup-request'}"
                  class="
                    text-white
                    flex
                    items-center
                    text-sm
                    font-medium
                    rounded-md
                  "
                >
                  <MapIcon
                    class="mr-3 h-6 w-6"
                    aria-hidden="true"
                  ></MapIcon>
                  <span class="side-menu-label">
                    {{ $t("message.pickup_request") }}
                  </span>
                </router-link>
              </template>
            </side-menu>
            <side-menu
              v-if="helper.isSpecificRole(['owner', 'manager'])"
              :menu-list="false"
              :route-list="[{ name: 'customer.list' }]"
            >
              <template v-slot:content>
                <router-link
                  :to="{ name: 'customer.list' }"
                  class="
                    text-white
                    flex
                    items-center
                    text-sm
                    font-medium
                    rounded-md
                  "
                >
                  <UsersIcon
                    class="mr-3 h-6 w-6"
                    aria-hidden="true"
                  ></UsersIcon>
                  <span class="side-menu-label">
                    {{ $t("message.customer") }}
                  </span>
                </router-link>
              </template>
            </side-menu>
            <!-- tds here call log -->
            <side-menu
            v-if="helper.isSpecificRole([
              'owner',
              'manager',
              'supervisor',
              'staff',
              'customer-service',
            ])"
            :menu-list="false"
            :route-list="[{ name: 'call-list' }]"
            >
            <template v-slot:content>
                <router-link
                  :to="{ name: 'call-list', params: { tab: 'pending' } }"
                  class="
                    text-white
                    flex
                    items-center
                    text-sm
                    font-medium
                    rounded-md
                  "
                >
                  <PhoneIcon
                    class="mr-3 h-6 w-6"
                    aria-hidden="true"
                  ></PhoneIcon>
                  <span class="side-menu-label">
                    {{ $t("message.call_log") }}
                  </span>
                </router-link>
              </template>
            </side-menu>
          <!-- api-integration -->
          <side-menu
            v-if="helper.isSpecificRole([
              'owner',
              'manager',
              'supervisor',
              'staff',
              'customer-service',
            ])"
            :menu-list="false"
            :route-list="[{ name: 'apiIntegration' }]"
            >
            <template v-slot:content>
                <router-link
                  :to="{ name: 'apiIntegration' }"
                  class="
                    text-white
                    flex
                    items-center
                    text-sm
                    font-medium
                    rounded-md
                  "
                >
                  <ChipIcon
                    class="mr-3 h-6 w-6"
                    aria-hidden="true"
                  ></ChipIcon>
                  <span class="side-menu-label">
                    {{ $t("message.api_integration") }}
                  </span>
                </router-link>
              </template>
            </side-menu>
          </nav>
          <div v-if="helper.isInDevelop()" class="flex justify-center mb-4">
            <span class="text-center text-white text-sm">
              Laravel {{ user?.laravel_version}}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<style lang="scss" scoped>
.minimize {
  .w-64 {
    width: auto;
  }

  .side-menu-label,
  .side-menu-arrow,
  .menu-dropdown {
    display: none;
  }

  .user_name {
    display: none;
  }

  .menu-list {
    display: none;
  }

  .logo-holder {
    padding: 0.8em;
    img {
      width: 60px;
      height: 60px;
    }
  }

  .menu-holder {
    button,
    a {
      justify-content: center;

      svg {
        margin: 0;
        width: 2em;

        &:last-child {
          display: none;
        }
      }
    }
  }
}
</style>



<script>
import constants from "Resources/config/constants.js";
import SideMenu from '@/components/SideBar/SideMenu.vue';
import SideMenuItem from '@/components/SideBar/SideMenuItem.vue'; // If using alias
import helper from "Resources/util/helper";
import Api from "Resources/util/api";

import { Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/vue";
import {
  HomeIcon,
  UserIcon,
  UsersIcon,
  UserGroupIcon,
  CubeIcon,
  DocumentReportIcon,
  PhoneIcon,
  CashIcon,
  MapIcon,
  ChipIcon
} from "@heroicons/vue/outline";

export default {
  name: "Sidebar",

  components: {
    SideMenu,
    SideMenuItem,
    HomeIcon,
    UserIcon,
    UsersIcon,
    UserGroupIcon,
    CubeIcon,
    DocumentReportIcon,
    Disclosure,
    DisclosureButton,
    DisclosurePanel,
    PhoneIcon,
    CashIcon,
    MapIcon,
    ChipIcon
  },
  data() {
    return {
      helper,
      constants,
      // logo: "https://fcs-assets.sgp1.digitaloceanspaces.com/logo/logo-icon.png",
      // logo: "https://access.cdndata.cloud/fcs/logo/logo-icon.png",
      logo: "https://files.cdndata.cloud/static/fcs-backend/logo/logo-icon.png",
      user: this.$store.state.auth.user,
      locale: this.$store.state.cache.locale,
      branch: {
        list: [],
        bkey: "id",
        bvalue: `name_${this.locale}`,
      },
      form: {
        branch: "",
      },
    };
  },
  computed: {},
  mounted() {
    this.transformBranch();
  },
  watch: {
    "form.branch": {
      handler() {
        if (this.branch.list.length == 0) {
          return;
        }
        this.setBranch();
      },
    },
  },
  methods: {
    transformBranch() {

    this.form.branch = this.user.branch ? this.user.branch : [];
      let list = this.user.jointed_branches
        ? this.user.jointed_branches.map((branch) => {
            return {
              id: branch.id,
              name_en: branch.name_en,
              name_mm: branch.name_mm,
            };
          })
        : [];

      this.branch = {
        list: list,
        bkey: "id",
        bvalue: `name_${this.locale}`,
      };
    },

    setBranch() {
      if (this.form.branch && this.user.branch.id == this.form.branch.id) {
        return;
      }
      if (this.form.branch) {
        Api.puller(`/api/agent/switch_branch/${this.user.id}`, {
          branch_id: this.form.branch.id,
        })
          .then((response) => {
            this.$store.dispatch("auth/fresh_account").then((response) => {
              this.user = this.$store.state.auth.user;
              setTimeout(() => {
                // EventBus.$emit('reload');
                window.location.reload();
              }, 500);
            });
          })
          .catch(helper.flashErrorMessage)
          .finally(() => {});
      }
    },
  },
};
</script>
